import { dashboardFilters } from "../../constants/dashboards/dashboardFilters.constant";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentDateFilters } from "../../types/dashboards/dashboardComponent.type";

export const getDashboardFilterLabel = (value: string, options?: number | {
  ignoreDateRange?: boolean;
}) => {
  if (typeof options === 'object' && options?.ignoreDateRange && (value === DashboardComponentDateFilters.StartDate || value === DashboardComponentDateFilters.EndDate)) {
    if (value === DashboardComponentDateFilters.StartDate) {
      return 'Data inicial';
    }

    return 'Data final';
  }

  if (value === DashboardComponentDateFilters.StartDate) {
    return dashboardFilters[DashboardFilters.DateRange];
  }

  if (value === DashboardComponentDateFilters.EndDate) {
    return null;
  }

  const filterLabel = dashboardFilters[value as DashboardFilters];

  if (!filterLabel) {
    return null;
  }

  return filterLabel;
}
